import Component, {
  productMetaData,
} from "~/route-containers/product.container";
import { kitLoader } from "~/loaders/kit.loader";
export { productMetaData as meta };

export { kitLoader as loader };

export default Component;
